/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import idx from 'idx';

import ErrorActions from 'actions/ErrorActions';
import ToastActions from 'actions/ToastActions';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import LinkConstants from 'constants/LinkConstants';
import GET_CLASS_PROFILE_QUERY from 'groups/queries/ClassProfileQuery.gql';

import PeopleListViewAllAnnouncements from './PeopleListViewAllAnnouncements';

import type { ClassProfile, ClassProfile_classes } from 'groups/queries/__generated__/ClassProfile';
import type { errorFragment } from 'queries/__generated__/errorFragment';

type Props = {
  groupUuid: string,
  group: ?ClassProfile_classes,
  loading: boolean,
  error: errorFragment,
  onBackClicked?: () => void,
  onClose: () => void,
  refetch: () => Promise<ClassProfile>,
};

class PeopleListViewAllAnnouncementsDataContainer extends React.Component<Props> {
  componentDidUpdate() {
    const { error, loading, group, onBackClicked, onClose } = this.props;

    if (error) {
      ErrorActions.serverError(error);
    }

    if (!loading && !group) {
      ToastActions.showErrorToast(
        `
          There was an error. Please try again, or email
          ${LinkConstants.SUPPORT_EMAIL}
          for help.
        `
      );

      if (onBackClicked) {
        onBackClicked();
      } else {
        onClose();
      }
    }
  }

  render() {
    const { group, loading, onBackClicked, onClose } = this.props;

    if (loading) {
      return <CenteredLoadingIndicator height={50} size="small" />;
    }

    if (group) {
      return (
        <PeopleListViewAllAnnouncements
          group={group}
          onBackClicked={onBackClicked}
          onClose={onClose}
        />
      );
    }

    return null;
  }
}

const withClassProfile = graphql(GET_CLASS_PROFILE_QUERY, {
  options: ({ groupUuid }) => {
    return {
      variables: {
        classUuid: groupUuid,
      },
    };
  },
  props: ({ data }) => ({
    loading: data.loading,
    error: data.error,
    group: idx(data.classes, _ => _[0]),
    refetch: data.refetch,
  }),
});

export { PeopleListViewAllAnnouncementsDataContainer };

export default withClassProfile(PeopleListViewAllAnnouncementsDataContainer);
